import React from 'react';

const TONE_STYLES = {
  warning: {
    accent: '#f39c12',
    border: 'rgba(243, 156, 18, 0.28)',
    background: 'rgba(243, 156, 18, 0.1)',
  },
  positive: {
    accent: '#27ae60',
    border: 'rgba(39, 174, 96, 0.28)',
    background: 'rgba(39, 174, 96, 0.1)',
  },
  neutral: {
    accent: '#2e86c1',
    border: 'rgba(46, 134, 193, 0.28)',
    background: 'rgba(46, 134, 193, 0.1)',
  },
};

const styles = {
  card: {
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
    padding: 18,
    borderRadius: 12,
    border: '1px solid var(--color-border)',
    background: 'var(--color-surface)',
  },
  eyebrow: {
    fontFamily: 'var(--font-heading)',
    fontSize: 10,
    fontWeight: 700,
    letterSpacing: 1.4,
    textTransform: 'uppercase',
  },
  title: {
    fontFamily: 'var(--font-heading)',
    fontSize: 18,
    fontWeight: 700,
    color: 'var(--color-text)',
    lineHeight: 1.25,
  },
  pillRow: {
    display: 'flex',
    gap: 8,
    flexWrap: 'wrap',
  },
  pill: {
    display: 'inline-flex',
    alignItems: 'center',
    padding: '5px 10px',
    borderRadius: 999,
    fontFamily: 'var(--font-heading)',
    fontSize: 10,
    fontWeight: 700,
    letterSpacing: 1,
    textTransform: 'uppercase',
  },
  section: {
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
  },
  sectionLabel: {
    fontFamily: 'var(--font-heading)',
    fontSize: 10,
    fontWeight: 700,
    letterSpacing: 1.2,
    textTransform: 'uppercase',
    color: 'var(--color-text-dim)',
  },
  sectionBody: {
    fontFamily: 'var(--font-body)',
    fontSize: 14,
    color: 'var(--color-text)',
    lineHeight: 1.5,
  },
};

export default function FocusAreaTile({
  tone = 'neutral',
  eyebrow,
  title,
  pills = [],
  sections = [],
  variant = 'hero',
}) {
  if (!title) return null;

  const toneStyle = TONE_STYLES[tone] || TONE_STYLES.neutral;
  const titleSize = variant === 'compact' ? 15 : 18;

  return (
    <div
      style={{
        ...styles.card,
        borderColor: toneStyle.border,
        background: `linear-gradient(180deg, ${toneStyle.background}, var(--color-surface))`,
      }}
    >
      {eyebrow && (
        <div style={{ ...styles.eyebrow, color: toneStyle.accent }}>
          {eyebrow}
        </div>
      )}

      <div style={{ ...styles.title, fontSize: titleSize }}>{title}</div>

      {pills.length > 0 && (
        <div style={styles.pillRow}>
          {pills.map((pill, index) => (
            <span
              key={`${pill.label}-${index}`}
              style={{
                ...styles.pill,
                color: pill.accent ? toneStyle.accent : 'var(--color-text-dim)',
                background: pill.accent ? toneStyle.background : 'rgba(255,255,255,0.04)',
              }}
            >
              {pill.label}
            </span>
          ))}
        </div>
      )}

      {sections.filter((section) => section?.body).map((section) => (
        <div key={section.label} style={styles.section}>
          <div style={styles.sectionLabel}>{section.label}</div>
          <div style={styles.sectionBody}>{section.body}</div>
        </div>
      ))}
    </div>
  );
}
